import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Page from '../Page.js';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import PageContentWrapper from "../../components/PageContentWrapper.js";
import FormPartial from './FormPartial.js';
import HeadUser from '../../models/HeadUser.js';
import { getApi } from '../../api/endpoints.js';
import { toast } from 'react-toastify';

const New = (props) => {
  const navigate = useNavigate();
  const [headUser, setHeadUser] = useState(new HeadUser());
  const [createApi] = getApi('createUser');

  const createRecord = async (params) => {
    try {
      await createApi(params).unwrap();
      toast.success("Head User Created Successfully")
      navigate("/manage_users")
    } catch (error) {
      toast.error(error.data.message);
      let headUserObj = new HeadUser(headUser);
      headUserObj.set_api_errors(error.data.data.errors);
    }
  }

  const handleSubmitFunction = () => {
    try{
      createRecord(new HeadUser(headUser).toApiJson());
    } catch(error){
      setHeadUser(new HeadUser(headUser));
    }
  }

  const handleCancelFunction = () => {
    navigate('/manage_users');
  }

  return <Page
      uiPage={uiManager.getUiPage(PAGES.NewHeadUserPage.name)}
      breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Head Users", url: '/manage_users' }, { label: "Add New Head User" }]}
      className={'new-head-user-page'}
    >
      <PageContentWrapper contentHeading={"Generate New Head User"}>
        <div className='m-3'>
          <div className='mb-4 col'>
            <form className="row g-3" autoComplete="off">
              <FormPartial headUser={headUser} setHeadUser={setHeadUser} />
              <div className='mb-4 col'>
                <div>
                  <button style={{ float: 'inline-start' }} type="button" className="btn btn-voltup-theme" onClick={handleCancelFunction}>
                    Back
                  </button>
                  <button type="button" className="btn btn-voltup-theme ms-3" onClick={handleSubmitFunction}>
                    Create
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </PageContentWrapper>
    </Page>
}

export default New;
